import { useMemo } from "react";
import useListSearch from "./useListSearch";
import { getActiveFilterChips, groupFilterDefinitions, splitFilterDefinitions } from "./listHelpers";

// ============================================================
// useListPage — assemble ce qu'une page de liste pilotée par définitions
// attend : l'état de recherche (useListSearch), les définitions groupées pour
// le panneau (ListFilters), les chips des filtres actifs et la possibilité de
// réinitialiser. La recherche libre (`terms`) a son propre champ : elle ne
// fait pas de chip et n'entre pas dans le compteur du bouton « Filtres ».
// `definitions` : voir FilterField ; `groups` : [{ id, title }].
// Une définition `principal: true` quitte le panneau pour la barre de
// recherche (`principalFilters`, rendus par InlineFilters) ; le bouton du
// panneau ne compte alors que les filtres restés dans le panneau.
// ============================================================
export default function useListPage({ definitions = [], groups = [], ...options }) {
  const list = useListSearch(options);
  const defaults = options.defaultFilters || {};

  const { principal, secondary } = useMemo(() => splitFilterDefinitions(definitions), [definitions]);
  const grouped = useMemo(
    () => groupFilterDefinitions(definitions, groups),
    [definitions, groups]
  );
  const chips = getActiveFilterChips(list.filters, definitions, defaults);
  const panelChips = getActiveFilterChips(list.filters, secondary, defaults);
  const terms = list.filters.terms;
  const termsActive = !!terms && terms !== (defaults.terms || "");

  return {
    ...list,
    groups: grouped,
    principalFilters: principal,
    hasPanelFilters: grouped.length > 0,
    chips,
    activeFiltersCount: chips.length,
    panelActiveFiltersCount: panelChips.length,
    canReset: chips.length > 0 || termsActive,
  };
}
